import { memo } from "react";
import { FieldStatus } from "../../types/FieldStatuses";
import { Bubble } from "./Bubble";
import { ExpandingTooltipReturn } from "../hooks/useAdvancedTooltip";
import "../../styles/circles.css";

type Props = {
  status?: FieldStatus;
  tProps?: ExpandingTooltipReturn["triggerProps"];
};

const FieldStatusBubble = (props: Props) => {
  if (props.status == null || props.status === "NO_STATUS") {
    return null;
  }
  const statusText =
    props.status.charAt(0).toUpperCase() + props.status.slice(1).toLowerCase();

  let className = "";
  switch (props.status) {
    case "BLANK": {
      className = "warning";
      break;
    }
    case "ERROR": {
      className = "error";
      break;
    }
    case "MATCH": {
      className = "normal";
      break;
    }
    case "EMPTY": {
      className = "darkgreen";
      break;
    }
    case "HARDCODE": {
      className = "notification";
      break;
    }
    case "REUSE": {
      className = "notification";
      break;
    }
  }

  return (
    <Bubble tProps={props.tProps} text={statusText} className={className} />
  );
};

const MemoFieldStatusBubble = memo(FieldStatusBubble);
export { MemoFieldStatusBubble as FieldStatusBubble };
